import React from "react";
import { SanityImage, SanityRawContent } from "../../model/common";
import styles from "./HomePageGetStartedBlock.module.scss";
import { Row, Col, Wrapper } from "../Grid";
import LandingPageSectionCard from "../LandingPageSectionCard/LandingPageSectionCard";
import { imageUrlBuilder } from "../../utils/images";

interface HomePageGetStartedBlockProps {
  image: SanityImage;
  content: SanityRawContent;
}

const HomePageGetStartedBlock = ({
  content,
  image
}: HomePageGetStartedBlockProps) => (
  <Wrapper className={styles.root}>
    <Row justify="center" className={styles.noMargin}>
      <Col md={7} sm={10} xs={12} className={styles.maskCol}>
        <div className={styles.mask}>
          <LandingPageSectionCard
            className={styles.content}
            content={content}
          />
        </div>
      </Col>
    </Row>
    <Row className={styles.noMargin}>
      <Col className={styles.noPadding}>
        <img
          className={styles.image}
          src={
            imageUrlBuilder
              .image(image)
              .format("jpg")
              .width(1440)
              .ignoreImageParams()
              .url()!
          }
          alt={image.alt}
        />
      </Col>
    </Row>
  </Wrapper>
);

export default HomePageGetStartedBlock;
